<template>
  <label class="flex-column form-row input-wrapper">
    <span class="block label-text">{{labelText}}</span>
    <input class="rounded"
           v-model="modeled"
           :name="name"
           :disabled="disabled"
           :class="{postcode:postcode, validation: (validation && !modelValue) || (modelValue && isValid && type==='email') }"
           :type="type"
           :maxlength="maxLength"
           :placeholder="placeholder">
  </label>
</template>

<script>
import {ref, watch} from "vue";
export default {
  name: "input-wrapper",
  props:{
    modelValue: String,
    labelText:String,
    name:String,
    placeholder: String,
    type:{type: String, default:"text"},
    maxLength: String,
    postcode: Boolean,
    disabled:Boolean,
    validation:Boolean,
  },
  setup(props, {emit}){
    const modeled = ref(props.modelValue)
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    const isValid = ref(true)

    watch(() => props.modelValue, (val) => {
      modeled.value = val
    })

    watch(() => modeled.value, (val) => {
      if (props.type === "email"){
        isValid.value = !isEmailValid(val);
      }

      emit("update:modelValue", val)
    })

    function isEmailValid(val) {
      return (val === "")? "" : !!(reg.test(val));
    }

    return {modeled, isValid}
  }
}
</script>

<style scoped>
.form-row {
  width: 48%;
}
.form-row > span.label-text {
  padding-left: 14px;
  font-size: .9rem;
  width: 100%;
  margin-bottom: 5px;
}
.form-row > input {
  padding-left: 14px;
  width: 100%;
  background-color: white;
  border: 2px solid #f5f6fa;
  height: 40px;
  font-size: 1rem;
}
.form-row > input:focus {
  border-color: #797979;;
}
.form-row > input::placeholder {
  color: #c8c8c9;
  font-size: .9rem;
}
.form-row > input:focus::placeholder {
  color: #b7b7b8;
  font-size: .9rem;
}
</style>
